import { useInfiniteQuery, useQuery, useQueryClient, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { generateUtmExt, getLocalStorage, setLocalStorage } from '../../common/common';
import { renderHeaderOnce } from '../../Store/actions';
import axiosInstance from '../../Store/helper/axiosInstance';
import { DASHBOARD_ALL_DATA } from '../QueryKeys/dashboard.key';
import {
  GRANDROUND_DETAILS,
  GRANDROUND_LIST,
  GRANDROUND_MEDWIKI,
  GRANDROUND_SESSION,
  GRANDROUND_SPQ,
  GRANDROUND_VIDEOS
} from '../QueryKeys/grandround.key';
import { GET_VAULT_LIST } from '../QueryKeys/vault.key';
import useFeedInitialData from '../utils/useFeedInitialData';

const staleTime = 300000;
const cacheTime = 600000;

export const useGrandRoundList = (onSuccess, onError) => {
  console.log(GRANDROUND_SPQ);
  return useInfiniteQuery(
    GRANDROUND_LIST,
    ({ pageParam = 0 }) => axiosInstance.get(`gr/listing?from=${pageParam}&to=10`),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          // console.log(allPages.length);
          return allPages.length * 10;
        } else {
          return undefined;
        }
      },
      staleTime: staleTime,
      cacheTime: cacheTime
    }
  );
};
export const useGrandRoundDetails = (id, onSuccess, onError, enabled) => {
  const queryClient = useQueryClient();

  return useQuery(
    [GRANDROUND_DETAILS, id],
    () => axiosInstance.get(`gr/detail?type_id=${id}${generateUtmExt()}`),
    {
      onSuccess,
      onError,
      enabled,
      refetchOnWindowFocus: false,
      select: (response) => response.data.data[0],
      initialData: () => {
        const grList =
          queryClient.getQueryData(GRANDROUND_LIST)?.pages?.map((page) => page.data.data).length > 0
            ? queryClient
                .getQueryData(GRANDROUND_LIST)
                ?.pages?.map((page) => page.data.data)
                ?.flat()
                ?.find((_s) => _s.type_id == id)
            : null;
        const grVault = queryClient
          .getQueryData(GET_VAULT_LIST)
          ?.data?.data?.find((e) => e.type_id == id);
        const grDashboard = queryClient
          .getQueryData(DASHBOARD_ALL_DATA)
          ?.data?.data?.find((_s) => _s.type_id == id);
        const [grChannel, grDashboardUiV3] = useFeedInitialData('gr', id);
        const gr = grList || grVault || grDashboard || grChannel || grDashboardUiV3;
        if (gr) {
          return { data: { data: [gr] } };
        } else {
          return undefined;
        }
      }
    }
  );
};
const returnQueryGrKey = (type) => {
  switch (type) {
    case 'session':
      return GRANDROUND_SESSION;
    case 'medwiki':
      return GRANDROUND_MEDWIKI;
    case 'survey':
      return GRANDROUND_SPQ;

    default:
      return '';
  }
};
const returnQueryApi = (id, type) => {
  switch (type) {
    case 'session':
      return `gr/session?type_id=${id}`;
    case 'medwiki':
      return `gr/medwiki?type_id=${id}`;
    case 'survey':
      return `gr/survey?type_id=${id}`;

    default:
      return '';
  }
};
export const useGrandRoundContent = (id, type, onSuccess, onError) => {
  // axiosInstance.get(returnQueryApi(190, 'survey')).then((res) => console.log(res.data.data));
  return useQuery([returnQueryGrKey(type), id], () => axiosInstance.get(returnQueryApi(id, type)), {
    onSuccess,
    onError,
    select: (response) => response.data.data,
    staleTime: staleTime,
    cacheTime: cacheTime,
    refetchOnWindowFocus: false
  });
};
export const useGrandRoundVideos = (id) => {
  return useInfiniteQuery(
    [GRANDROUND_VIDEOS, id],
    ({ pageParam = 0 }) =>
      axiosInstance.get(`gr/archiveVideoList?type_id=${id}&to=5&from=${pageParam}`),
    {
      refetchOnWindowFocus: false,
      staleTime: staleTime,
      cacheTime: cacheTime,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 5) {
          // console.log(allPages.length);
          return allPages.length * 5;
        } else {
          return undefined;
        }
      }
    }
  );
};

const saveLike = (data) => {
  return axiosInstance.post('knwlg/save_like', data);
};

export const useAddLike = (type, type_id) => {
  const queryClient = useQueryClient();

  return useMutation(saveLike, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION SAVELIKE', obj);
      const queryKeysArr = [GRANDROUND_DETAILS, type_id];
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        // console.log('PREVIOUS-oldQueryData======>', oldQueryData.data.data[0]);
        let temp_data = oldQueryData;
        temp_data.data.data[0].myrating
          ? (temp_data.data.data[0].rating -= 1)
          : (temp_data.data.data[0].rating += 1);
        temp_data.data.data[0].myrating = !temp_data.data.data[0].myrating;
        return temp_data;
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([GRANDROUND_DETAILS, type_id]);
    }
  });
};

const saveVault = (data) => {
  return axiosInstance.post('knwlg/vault_switching', data);
};

export const useAddVault = (type, type_id) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(saveVault, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION ADDVAULT', obj);
      const queryKeysArr = [GRANDROUND_DETAILS, type_id];
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        // console.log('PREVIOUS oldQueryData======>', oldQueryData);
        let temp_data = oldQueryData;
        if (temp_data.data.data[0].vault == 0) {
          temp_data.data.data[0].vault = 1;
        } else {
          temp_data.data.data[0].vault = 0;
        }
        return temp_data;
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([GRANDROUND_DETAILS, type_id]);
    },
    onSuccess: (resp) => {
      const res = resp.data;
      let vaultCount = getLocalStorage('vaultCount', false)
        ? parseInt(getLocalStorage('vaultCount', 0))
        : 0;
      if (res.data == 0) {
        setLocalStorage('vaultCount', vaultCount - 1);
      } else {
        setLocalStorage('vaultCount', vaultCount + 1);
      }
      dispatch(renderHeaderOnce());
    }
  });
};
